import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { ContentBlock } from "../../pages/components/";
import { BlockingLoader } from "../../common/components/loader";
import BaseFormContainer from "../../common/components/form/BaseFormContainer";

import * as contentActions from "../content.actions";
import * as channelActions from "../../channel/channel.actions";
import { getAllChannels } from "../../channel/channel.selectors";
import ContentForm from "./ContentForm";

import Button from "../../../ui/button/Button";
import colorThemes from "../../../ui/colorThemes";
import { Localize } from "../../../locale/localization";
import { StyledFormFooter } from "../../common/components/form/ui";
import Dialog from "../../common/components/Dialog";
import each from "lodash/each";
import { sanitizeHtmlContent } from "../../../utils/content-utils";

const constraints = {
  name: {
    presence: {
      message: `^${Localize("form.content.name.error")}`
    }
  },
  content: {
    presence: {
      message: `^${Localize("form.content.content.error")}`
    }
  },
  imageUrl: {},
  videoUrl: {}
};

class ContentFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      channel: "",
      name: "",
      category: "",
      tags: this.createTags(props.tags),
      targetings: this.createTargetings(props.targetings),
      pinned: false,
      content: "",
      contentPreview: false,
      imageUrl: "",
      videoUrl: ""
    };

    this.state = {
      ...this.state,
      isUploading: false,
      formData,
      _id: this.props.id,
      dialogOpen: false
    };
  }

  componentWillReceiveProps(nextProps) {
    const { contentItem } = nextProps;
    const newTags = this.createTags(nextProps.tags, contentItem);
    const newTargetings = this.createTargetings(
      nextProps.targetings,
      contentItem
    );
    const newPinned =
      contentItem && contentItem.pinned ? contentItem.pinned : false;
    const { formData } = this.state;

    // console.log("ContentFormContainer componentWillReceiveProps, newTargetings:", newTargetings);

    this.setState({
      formData: {
        ...formData,
        tags: newTags,
        targetings: newTargetings,
        pinned: newPinned
      }
    });
  }

  componentWillMount = () => {
    const { id, getContent, getChannels, tags, targetings } = this.props;

    getChannels();

    if (id) {
      getContent(id).then(() => {
        const { contentItem } = this.props;
        const newTags = this.createTags(tags, contentItem);
        const newTargetings = this.createTargetings(targetings, contentItem);
        const newPinned =
          contentItem && contentItem.pinned ? contentItem.pinned : false;

        const {
          _id = "",
          channel = "",
          name = "",
          category = "",
          content = "",
          imageUrl = "",
          videoUrl = ""
        } = contentItem;

        const { formData } = this.state;

        this.setState(
          {
            formData: {
              ...formData,
              _id,
              channel,
              name,
              category,
              tags: newTags,
              targetings: newTargetings,
              pinned: newPinned,
              content,
              imageUrl,
              videoUrl
            }
          },
          this.validate
        );
      });
    }
  };

  getConstraints = () => {
    const { contentType } = this.props;
    const channelRequired = contentType === "rules";
    const categoryRequired = contentType !== "rules";
    const targetingRequired = contentType !== "rules" && contentType !== "news";

    const channel = !channelRequired
      ? null
      : {
          presence: {
            message: `^${Localize("form.content.channel.error")}`
          }
        };
    const category = !categoryRequired
      ? null
      : {
          presence: {
            message: `^${Localize("form.content.category.error")}`
          }
        };
    const targetings = !targetingRequired
      ? null
      : {
          presence: {
            message: `^${Localize("form.content.targetings.error")}`
          },
          validateTargetings: {
            message: `^${Localize("form.content.targetings.error")}`
          }
        };

    if (this.props.contentType === "news") {
      return {
        ...constraints,
        targetings
      };
    } else {
      return {
        ...constraints,
        channel,
        category,
        targetings
      };
    }
  };

  doSubmit = formData => {
    const { updateContent, createContent, contentType } = this.props;

    let modifiedFormData = {
      ...formData,
      type: contentType
    };

    if (contentType === "news") {
      delete modifiedFormData.channel;
    }

    this.flattenTags(modifiedFormData);
    this.flattenTargetings(modifiedFormData);
    modifiedFormData.content = sanitizeHtmlContent(modifiedFormData.content);
    // console.log("form submit, formData", modifiedFormData);

    if (this.props.id) {
      updateContent({
        _id: this.props.id,
        ...modifiedFormData
      }).then(this.handleResponse);
    } else {
      createContent(modifiedFormData).then(this.handleResponse);
    }
  };

  handleResponse = action => {
    if (action.response.status === "ok") {
      //NOTE: targetings special delete update trigger here
      const id = action.response.result;
      // const targetings = this.createTargetings(
      //   this.props.targetings,
      //   action.response.entities.content[id].targetings
      // );
      this.setState({
        submitCompleted: true,
        submitted: true,
        _id: id
        // targetings: targetings
      });
    } else {
      this.setState({
        submitFailed: true,
        submitted: true
      });
    }
  };

  onViewArticleClick = event => {
    event.preventDefault();

    const { history, contentType } = this.props;
    const { _id } = this.state;
    history.push(`/${contentType}/${_id}`);
  };

  onRetry = event => {
    event.preventDefault();

    this.setState(
      {
        submitted: false,
        submitFailed: false
      },
      () => {
        this.doSubmit(this.state.formData);
      }
    );
  };

  onCancel = event => {
    event.preventDefault();

    const { cancelPath, history } = this.props;
    history.replace(cancelPath);
  };
  /*
  onDelete = (event) => {
    event.preventDefault();
    //TODO
    const { deleteContent } = this.props;
    deleteContent(this.props.id).then(() => {
      const { cancelPath, history } = this.props;
      history.replace(cancelPath);
    });
  }
*/
  onDelete = event => {
    event.preventDefault();
    this.setState({
      dialogOpen: true
    });
  };

  cancelDelete = event => {
    this.setState({
      dialogOpen: false
    });
  };

  confirmDelete = event => {
    const { deleteContent } = this.props;
    deleteContent(this.props.id).then(() => {
      this.setState({
        dialogOpen: false,
        deletableEntity: null
      });
      const { cancelPath, history } = this.props;
      history.replace(cancelPath);
    });
  };

  onFileInputChange = event => {
    this.setState(
      {
        isUploading: true,
        formError: ""
      },
      this.forceUpdate
    );
    const { uploadImage } = this.props;
    const target = event.target;
    const uploadFormData = new FormData();
    uploadFormData.append("file", target.files[0]);
    const { formData } = this.state;
    uploadImage(uploadFormData)
      .then(action => {
        this.setState(
          {
            formData: {
              ...formData,
              imageUrl: action.response.url
            },
            isUploading: false,
            formError: ""
          },
          this.validate
        );
      })
      .catch(error => {
        this.setState(
          {
            isUploading: false,
            formError: `${Localize("form.content.image.error")}`
          },
          this.validate
        );
      });
  };

  // textarea html preview toggle
  onContentPreviewToggle = event => {
    const { formData } = this.state;
    const clean = sanitizeHtmlContent(formData.content);
    const preview = !formData.contentPreview;

    this.setState({
      formData: {
        ...formData,
        content: clean,
        contentPreview: preview
      }
    });
  };

  createTags = (tags, contentItem) => {
    let items = [];
    each(tags, function(tag) {
      let tagSelected = false;
      if (contentItem && contentItem.tags) {
        each(contentItem.tags, function(ct) {
          if (ct === tag.label) {
            tagSelected = true;
          }
        });
      }

      items.push({
        name: tag.label,
        label: tag.label,
        value: tagSelected
      });
    });

    return items;
  };

  onTagChange = event => {
    const target = event.target;
    const { name } = target;
    let tags = this.state.formData.tags;
    each(tags, function(item) {
      if (item.name === name) {
        item.value = !item.value;
      }
    });

    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        tags: tags
      }
    });
  };

  flattenTags = formData => {
    let names = [];
    each(formData.tags, function(tag) {
      if (tag.value) names.push(tag.name);
    });
    formData.tags = names;
  };

  createTargetings = (targetings, contentTargetings) => {
    let selection = [];
    if (contentTargetings && contentTargetings.targetings) {
      each(contentTargetings.targetings, function(item) {
        selection.push({
          role: item.role,
          channel: { name: item.channel.name, _id: item.channel._id },
          _id: item._id
        });
      });
    }

    // initial selection
    if (selection.length === 0) {
      selection.push({
        channel: { name: "", _id: "" },
        role: "",
        _id: ""
      });
    }

    const items = {
      roles: this.props.roles,
      targetings: this.props.targetings,
      selection: selection
    };

    // console.log("targetings:", items);
    return items;
  };

  onTargetingChange = targetings => {
    const { formData } = this.state;
    this.setState({
      formData: {
        ...formData,
        targetings: targetings
      }
    });
  };

  flattenTargetings = formData => {
    let targetings = [];
    each(formData.targetings.selection, function(selection) {
      if (selection.channel.role !== "" && selection.channel._id !== "") {
        targetings.push({
          role: selection.role,
          channel: { name: selection.channel.name, _id: selection.channel._id },
          _id: selection._id
        });
      }
    });
    formData.targetings = targetings;
  };

  render() {
    const { channels, id, contentType } = this.props;

    const action = !!id ? "edit" : "add";
    const title = `${contentType}.${action}`;
    const submitHead = Localize(contentType + ".created");
    const submitViewBt = Localize(contentType + ".created.view");
    const submitListBt = Localize(contentType + ".created.list");

    return (
      <div>
        <ContentBlock title={Localize(title)}>
          {!this.state.submitted ? (
            <ContentForm
              enabled={!this.state.isSubmitting && !this.state.isUploading}
              onSubmit={this.onSubmit}
              onDelete={this.onDelete}
              onCancel={this.onCancel}
              onInputChange={this.onInputChange}
              onBlur={this.onBlur}
              onFileInputChange={this.onFileInputChange}
              onContentPreviewToggle={this.onContentPreviewToggle}
              onTagChange={this.onTagChange}
              onTargetingChange={this.onTargetingChange}
              errors={this.state.errors}
              touchedFields={this.state.touchedFields}
              isValid={this.state.isValid}
              channel={this.state.formData.channel}
              name={this.state.formData.name}
              category={this.state.formData.category}
              content={this.state.formData.content}
              contentPreview={this.state.formData.contentPreview}
              imageUrl={this.state.formData.imageUrl}
              videoUrl={this.state.formData.videoUrl}
              pinned={this.state.formData.pinned}
              channels={channels}
              tags={this.state.formData.tags}
              targetings={this.state.formData.targetings}
              formError={this.state.formError}
              contentType={contentType}
              showDeleteButton={!!id}
            />
          ) : this.state.submitCompleted ? (
            <div>
              <p>{submitHead}</p>
              <StyledFormFooter column>
                <Button
                  theme={colorThemes.LIGHT}
                  onClick={this.onViewArticleClick}
                >
                  {submitViewBt}
                </Button>
                <Button theme={colorThemes.LIGHT} onClick={this.onCancel}>
                  {submitListBt}
                </Button>
              </StyledFormFooter>
            </div>
          ) : (
            <div>
              <p>{Localize("error.general")}</p>
              <StyledFormFooter column>
                <Button theme={colorThemes.LIGHT} onClick={this.onRetry}>
                  {Localize("error.retry")}
                </Button>
                <Button theme={colorThemes.LIGHT} onClick={this.onCancel}>
                  {Localize(`${contentType}.created.list`)}
                </Button>
              </StyledFormFooter>
            </div>
          )}
        </ContentBlock>

        <Dialog
          open={this.state.dialogOpen}
          title={Localize(`${contentType}.delete.confirm`)}
          cancelLabel={Localize("action.cancel")}
          confirmLabel={Localize(`${contentType}.delete`)}
          onCancel={this.cancelDelete}
          onConfirm={this.confirmDelete}
        >
          <p>{Localize("form.no.cancel")}</p>
        </Dialog>

        <BlockingLoader isLoading={this.state.isUploading} />
      </div>
    );
  }
}

const mapStateToProps = (state, { match, cancelPath, type = "news" }) => {
  const { id } = match.params;

  const contentItem = state.entities.content.byId[id];
  const channels = type === "news" ? null : getAllChannels(state);

  const tags = state.entities.content.tags;
  const roles = state.auth.roles;
  const targetings = state.auth.targetings;

  return {
    id,
    contentItem,
    channels,
    cancelPath,
    contentType: type,
    tags,
    roles,
    targetings
  };
};

const ConnectedContentFormContainer = connect(
  mapStateToProps,
  Object.assign({}, contentActions, channelActions)
)(ContentFormContainer);

export default withRouter(ConnectedContentFormContainer);



// WEBPACK FOOTER //
// ./src/modules/content/components/ContentFormContainer.js